<script setup lang="ts">

import { inject, Ref } from 'vue';
import Button from '../components/Button.vue';
import { Events } from '../events';
import Icon from '../Icon.vue';
import { placeholdAction } from './actions/placeholderAction';

  const {editor} = defineProps(['editor'])

  const blockToFix = inject<Ref<unknown[]>>('blockToFix')

function update(editor, gutter) {
  const { from, to } = editor.state.selection;  
  const editorNode = gutter.closest('.TheEditor');
  const coords = editor.view.coordsAtPos(to)
  const editorRect = editorNode.getBoundingClientRect();
  const relativeY = coords.top - editorRect.top;
  gutter.style.display = 'flex'
  gutter.style.top = (relativeY + editorNode.scrollTop ) + 'px'
  adjust(gutter, editorNode)
}

Events.listen(Events.SELECTION, ({detail}) => {
  const {editor} = detail;

  const { from, to } = editor.state.selection;  
  if (from === to) {
    const gutter: HTMLElement = document.querySelector('.TheGutter')
    gutter.style.display = 'none'
  } else {
    const gutter: HTMLElement = document.querySelector('.TheGutter')
    update(editor, gutter)
  }

})

Events.listen(Events.SCROLL, ({detail}) => {
  const {editor} = detail;
  const { from, to } = editor.state.selection;  
  if (from !== to) {
    const gutter: HTMLElement = document.querySelector('.TheGutter')
    update(editor, gutter)
  }
})


function adjust(gutter, editor) {

  const gutterRect = gutter.getBoundingClientRect();
  const editorRect = editor.getBoundingClientRect();

  if (gutterRect.top < editorRect.top + 3) {
    gutter.style.top = ( editor.scrollTop + 3 ) + 'px'
  } else if (gutterRect.bottom > editorRect.bottom - 3) {
    gutter.style.top = (editor.scrollTop  +  editorRect.height - gutterRect.height - 3) + 'px'
  }

}


</script>

<template>
  <div class="TheGutter shadow-md flex flex-col bg-base-300 gap-1 rounded-sm" >
    
    <Button placement="left" title="change with AI" class="btn-xs btn-ghost p-1" @action="editor.commands.aiHelp()">
      <Icon :size="16" name="ion--sparkles-sharp"/>
    </Button>
    <Button 
      placement="left" title="add to AI context" 
      :disabled="!blockToFix?.length"
      class="btn-xs btn-ghost p-1" @action="editor.commands.addMarkToFix()">
      <Icon :size="16" name="pixelarticons--text-add"/>      
    </Button>
  </div>  
</template>
<style lang='less'>
 .TheGutter {
   position: absolute;
   left: 3px;
   padding: 3px 3px;
 }
</style>